import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { class: "buyers-content" }
const _hoisted_7 = { class: "buyer-field" }
const _hoisted_8 = { class: "buyer-field" }
const _hoisted_9 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    showClose: false
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.modalTitle), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString($setup.modalDescription), 1),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "note" }, "Note: Skipping buyer names will affect reporting accuracy.", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("label", { class: "label" }, "Buyer 1", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "buyer-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.firstBuyer) = $event)),
                type: "text",
                placeholder: "Enter first buyer name"
              }, null, 512), [
                [_vModelText, $setup.firstBuyer]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label" }, "Buyer 2 (Optional)", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "buyer-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.secondBuyer) = $event)),
                type: "text",
                placeholder: "Enter second buyer name"
              }, null, 512), [
                [_vModelText, $setup.secondBuyer]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn cancel",
            onClick: $setup.close
          }, "Cancel"),
          _createElementVNode("button", {
            class: "btn confirm",
            onClick: $setup.confirm
          }, [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("span", { key: $setup.hasAnyBuyers }, _toDisplayString($setup.hasAnyBuyers ? "Confirm" : "Skip"), 1))
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}